import { ELedgerType, IReportLedgerType } from '@opengov/reporting-types';

/**
 * Sort the ledger types by their natural order, which is something defined in the heads of accountants.
 * @param ledgerTypes The ledger types in need of sorting.
 * @returns An array of ledger types sorted by accounting order.
 * @see REP-3600 for order expectations.
 */
export const sortLedgerTypes = (ledgerTypes: IReportLedgerType[]): IReportLedgerType[] => {
  const ltMap = new Map(ledgerTypes.map((ledgerType) => [ledgerType.filterValue, ledgerType]));
  const desiredOrder = ltMap.has(ELedgerType.ex)
    ? [ELedgerType.as, ELedgerType.li, ELedgerType.eq, ELedgerType.ex, ELedgerType.re, ELedgerType.ft]
    : [ELedgerType.re, ELedgerType.as, ELedgerType.li, ELedgerType.eq, ELedgerType.ft];
  return desiredOrder.map((lt) => ltMap.get(lt)).filter(Boolean);
};
